import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=40158752&"
import script from "./multipleChoice.vue?vue&type=script&lang=js&"
export * from "./multipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports